module.exports = __webpack_public_path__ + "img/12.5aa7f6b9.png";